/**
 * 日本語。
 *
 * キーは `cs.js` に由来します。足りないキーがあると英語のテキストが出ます
 * （それもなければチェコ語）。抜けがすぐ分かるようにするためです。
 *
 * この翻訳は、日本語を話すトランスの人にまだ読んでもらっていません。
 * トランスに関わる言葉づかいや呼び方は、ほかよりここで重みがあります。
 * おかしなところがあれば教えてください。直します。
 */
const ja = {

  // ── společné ──────────────────────────────────────────────────────────────
  'obecne.zpet': '戻る',
  'obecne.hledat': '検索',
  'obecne.nacitani': '読み込み中…',
  'obecne.zrusit': 'キャンセル',
  'obecne.ulozit': '保存',
  'obecne.odeslat': '送信',
  'obecne.vice': 'すべて表示',
  'obecne.jazyk': '言語',

  // ── přihlášení a registrace ───────────────────────────────────────────────
  'auth.podtitulek': 'トランスコミュニティのための安全な場所。ここでは率直に話し、助けを探し、支えを感じられます。',
  'auth.prihlaseni': 'ログイン',
  'auth.registrace': '新規登録',
  'auth.email': 'メールアドレス',
  'auth.heslo': 'パスワード',
  'auth.emailPriklad': 'you@example.com',
  'auth.prihlasitSe': 'ログイン',
  'auth.prihlasuji': 'ログイン中…',
  'auth.zapomenuteHeslo': 'パスワードをお忘れですか？',
  'auth.presGoogle': 'Google でログイン',
  'auth.spatneUdaje': 'メールアドレスかパスワードが違います',
  'auth.uspech': 'ログインしました。',
  'auth.googleChyba': 'Google でのログインに失敗しました',
  'auth.obnoveniHesla': 'パスワードの再設定',
  'auth.obnoveniOdeslano': 'そのメールアドレスが登録されていれば、再設定用のリンクが届きます。',
  'auth.zpetNaPrihlaseni': 'ログインに戻る',
  'auth.odeslatOdkaz': '再設定リンクを送る',
  'auth.obnoveniChyba': 'メールを送れませんでした。もう一度お試しください。',

  // druhý krok přihlášení
  'auth.jesteKod': 'あと一歩：コードの入力',
  'auth.jesteKodPopis': '認証アプリを開いて、Bloom のところに出ている6桁の数字を入力してください。',
  'auth.kod': 'コード',
  'auth.zalozniKodNapoveda': 'スマホが手元にない？ 設定したときに保存したバックアップコードのどれかを入力してください。',
  'auth.potvrdit': '確認',
  'auth.overuji': '確認中…',
  'auth.kodNesedi': 'そのコードは違います',
  'auth.zalozniDochazeji': (p) => `バックアップコードはあと ${p.pocet} 個です。プロフィールで新しく作ってください。`,

  // instalace a zabezpečení
  'auth.instalaceTitulek': 'Bloom をスマホに入れる方法',
  'auth.krokyAndroid': [
      'このページを Chrome で開く',
      '右上の三点アイコン（⋮）をタップ',
      '「ホーム画面に追加」または「アプリをインストール」を選ぶ',
      'インストールを確認する',
    ],
  'auth.krokyIos': [
      'このページを Safari で開く',
      '下のバーの共有アイコン（□↑）をタップ',
      '下にスクロールして「ホーム画面に追加」を選ぶ',
      '「追加」をタップして確定する',
    ],
  'auth.seznamChranene': [
      { silne: 'メンバーに関することは何も公開されません。', text: 'プロフィール、体験談、募集、質問、写真、アバターはログインした人にだけ渡されます。アカウントなしでは、どれもダウンロードも収集もできません。' },
      { silne: 'あなたのパスワードは誰も知りません', text: '——私たちもです。bcrypt のハッシュとして保存され、そこから元のパスワードは復元できません。' },
      { silne: '個人メッセージと添付は暗号化されています', text: '（AES と改ざん検知）サーバーのディスク上で。バックアップやディスクを手に入れた人も、意味のない文字列しか読めません。' },
      { silne: 'メッセージは自動で消えます', text: '決められた期間のあと（初期設定では90日）、音声メッセージや写真も一緒に。ここにないものは漏れません。' },
      { silne: 'あなたの移行の段階は非公開です', text: '自分で公開しない限り。ガイドでチェックした手順は他の人には見えません。' },
      { silne: 'メールアドレスと電話番号', text: 'は他のメンバーには決して表示されません。' },
      { silne: '', text: 'ログインは試行回数を制限することで、パスワードの推測から守られています。' },
      { silne: 'メッセージのエンドツーエンド暗号化。', text: 'オンにすると、本文と添付はあなた自身のブラウザで暗号化され、サーバーには意味のない文字列だけが届きます。鍵はあなたのパスワードで開き、端末から出ることはありません——だから中身は私たちにも読めません。裁判所に求められてもです。その代わり、パスワードを忘れると自分でも古いメッセージを読めなくなります。' },
      { silne: '', text: 'ログイン状態は残りません。ウィンドウを閉じたとき、そして10分操作がないときに、Bloom はあなたをログアウトさせます。' },
    ],
  'auth.seznamNeumime': [
      { silne: 'メタデータ', text: '——誰がいつ誰に書いたか——は、メッセージを届けるためにサーバーが知っている必要があります。エンドツーエンド暗号化でも隠せませんし、Signal でも同じです。' },
      { silne: '', text: 'Bloom はウェブアプリなので、開くたびに私たちのサーバーから暗号化のコードを読み込みます。サーバーを乗っ取った人は、理論上は書き換えたコードを配れます。それを防げるのはストアの署名付きアプリだけです——Signal にはそれがあり、ウェブ版にはありません。' },
      { silne: 'プロフィール', text: '——ニックネーム、自己紹介、アバター——は暗号化できません。サーバーが他のメンバーに表示しなければならないからです。' },
      { silne: '', text: '暗号化をオンにする前のメッセージは、サーバーのディスク上で暗号化されているだけで、エンドツーエンドではありません。' },
    ],
  'auth.instalaceAndroid': 'Android',
  'auth.instalaceIos': 'iPhone / iPad',
  'auth.instalacePoznamka': 'Bloom はアプリのように動き、オフラインでも使えます。データはいつも最新です。',
  'auth.zabezpeceniTitulek': 'Bloom はどう守られているか',
  'auth.zabezpeceniUvod': 'Bloom はトランスコミュニティの場所なので、繊細なことが集まります。それを守るために'
      + '私たちがしていること、そしてできないことを、飾らずに書きます。',
  'auth.coJeChranene': '守られているもの',
  'auth.coNeumime': 'Bloom にできないこと——正直に言っておきます',
  'auth.zabezpeceniZaver': 'プライバシーについて質問があるとき、弱点を見つけたときは、下の「問題を報告」を使ってください。真剣に受け止めます。',
  'auth.mvp': 'Bloom はまだ最初のバージョンで、コミュニティと一緒に良くしていっています。'
      + '不具合に出会ったり、アイデアがあれば、ぜひ教えてください。',
  'auth.nahlasitProblem': '問題を報告',
  'auth.clenu': () => '人のメンバー',
  'auth.prispevku': () => '件の投稿',
  'auth.odborniku': () => '人の専門家',
  'auth.nabidek': () => '件の募集',

  // ── registrace ────────────────────────────────────────────────────────────
  'reg.prezdivka': 'ニックネーム（重複不可）',
  'reg.prezdivkaPriklad': '3文字以上',
  'reg.telefon': '電話番号',
  'reg.volitelne': '（任意）',
  'reg.heslo': 'パスワード',
  'reg.hesloZnovu': 'パスワードをもう一度',
  'reg.zajmeno': '代名詞',
  'reg.oMne': '自己紹介',
  'reg.oMnePriklad': '自分について少しだけ…',
  'reg.registrovat': 'アカウントを作る',
  'reg.registruji': 'アカウントを作成中…',
  'reg.presGoogle': 'Google で登録',
  'reg.avatar': 'アバター',
  'reg.neboFoto': 'または自分の写真をアップロード',
  'reg.nahratFoto': '写真をアップロード',
  'reg.vlastni': '自分の写真',
  'reg.zeme': '国',
  'reg.kraj': '地域',
  'reg.nechciUvadet': '答えたくない',
  'reg.cesko': 'チェコ',
  'reg.svet': 'その他の国',

  // skupiny avatarů
  'reg.avatarFem': '女性寄り',
  'reg.avatarMask': '男性寄り',
  'reg.avatarNeutr': 'ニュートラル',
  'reg.avatarZvirata': '動物',

  // komunitní heslo
  'reg.komunitniHeslo': 'コミュニティの合言葉',
  'reg.komunitniHesloPriklad': 'コミュニティの合言葉を入力…',
  'reg.komunitniHesloPopis': 'Bloom はトランスコミュニティのための非公開の場所です。合言葉はコミュニティの誰かが教えてくれます。',
  'reg.napisAdminovi': '知り合いがいない場合は、管理者までメールしてください：',
  'reg.nevimHeslo': 'コミュニティの合言葉を知りません',
  'reg.jakZiskat': 'この非公開の場所を守っているのが合言葉です。手に入れ方：',
  'reg.krok1': '1. こちらにメールを書く：',
  'reg.krok2': '2. 簡単に自己紹介して、Bloom をどこで知ったか書く',
  'reg.krok3': '3. 管理者ができるだけ早く返信します',

  // kontrola hesla
  'reg.hesloKratke': 'パスワードは8文字以上にしてください',
  'reg.hesloMale': 'パスワードには小文字を入れてください',
  'reg.hesloVelke': 'パスワードには大文字を入れてください',
  'reg.hesloCislo': 'パスワードには数字を入れてください',
  'reg.hesloZnak': 'パスワードには記号を入れてください（!@#$%…）',
  'reg.pozadavek8': '8文字以上',
  'reg.pozadavekVelke': '大文字',
  'reg.pozadavekCislo': '数字',
  'reg.pozadavekZnak': '記号（!@#$%）',
  'reg.hesloNesouhlasi': 'パスワードが一致しません',
  'reg.prezdivkaKratka': 'ニックネームは3文字以上にしてください',
  'reg.hesloPovinne': 'コミュニティの合言葉は必須です',
  'reg.hotovo': 'アカウントを作りました。メールを確認して認証してください。',
  'reg.fotoVelka': '画像が大きすぎます（最大 2 MB）',
  'reg.chyba': '登録に失敗しました',

  // ── domovská stránka ──────────────────────────────────────────────────────
  'domu.citat': 'ここでは誰も完璧である必要はありません。Bloom は誰もが自分でいられる場所です——'
      + '経験を分かち合い、質問し、誰かを助けられる場所。決めつけも偏見もなしで。',
  'domu.citatAutor': '— Martina Sobková',
  'domu.prelozenoZCestiny': ' · チェコ語からの翻訳',
  'domu.vitej': 'ようこそ、',
  'domu.vCislech': '数字で見る Bloom',
  'domu.noveVKomunite': 'ここは初めて？',
  'domu.noveVKomunitePopis1': '目立たなくていい。写真もいらない。カミングアウトしていなくてもいい。',
  'domu.noveVKomunitePopis2': 'Bloom は自分のペースで始められる場所です。',
  'domu.rozcestnik1': 'ここに来るのは初めて',
  'domu.rozcestnik2': 'どこから始めればいいかわからない',
  'domu.rozcestnik3': '匿名のままでいたい',
  'domu.rozcestnik4': '専門家を探している',
  'domu.rozcestnik5': 'ほかの人の話をただ読みたい',
  'domu.otazky': '質問がある、もっと知りたい？ こちらへどうぞ：',
  'domu.doporucujeme': 'おすすめ',
  'domu.odbornici': '専門家',
  'domu.noviClenove': 'コミュニティの新しいメンバー',
  'domu.zadniNovi': 'まだ新しいメンバーはいません',
  'domu.nejnovejsiOtazky': '最新の質問',
  'domu.zadneOtazky': 'まだ質問はありません。',
  'domu.nejlepeHodnoceni': '評価の高い専門家',
  'domu.zadniHodnoceni': 'まだ評価された専門家はいません',
  'domu.zadneAktuality': 'まだニュースはありません',

  // dlaždice sekcí
  'domu.dlazdice.support': '自分にできることを差し出し、ほかの人から助けをもらう。',
  'domu.dlazdice.specialists': '心理士から形成外科医まで、確認済みの専門家を探せます。',
  'domu.dlazdice.legal': '法律の助け、記事、あなたの疑問への回答。',
  'domu.dlazdice.nearby': 'あなたの近くのサービスと専門家。',

  // počty
  'domu.pocetClenu': () => '人のコミュニティメンバー',
  'domu.pocetZkusenosti': () => '件の共有された体験談',
  'domu.pocetOdborniku': () => '人の確認済みの専門家',
  'domu.pocetNabidek': () => '件の助け合いの募集',

  // ── navigace a společné ovládání ──────────────────────────────────────────
  'nav.domu': 'ホーム',
  'nav.news': 'ニュース',
  'nav.stories': 'コミュニティの体験談',
  'nav.mapaSveta': '世界地図',
  'nav.support': '助け合い',
  'nav.specialists': 'トランスフレンドリーな専門家',
  'nav.legal': '法律の助け',
  'nav.pageants': 'コンテスト',
  'nav.nearby': '近くで探す',
  'nav.hledat': 'Bloom 内を検索',
  'nav.hledatPlaceholder': '人、専門家、記事を検索…',
  'nav.zpravy': 'メッセージ',
  'nav.profil': 'マイプロフィール',
  'nav.mojeCesta': '私の道のり',
  'nav.administrace': '管理',
  'nav.odhlasit': 'ログアウト',
  'nav.vsechnyVysledky': (p) => `「${p.dotaz}」の結果をすべて表示`,
  'nav.overEmail': 'メールアドレスを認証してください',
  'nav.menu': 'メニュー',

  // ── mapa světa ────────────────────────────────────────────────────────────
  'svet.titulek': '世界のなかの Bloom',
  'svet.podtitulek': '国を選ぶと、そこでコミュニティが集めてきたものが見られます。',
  'svet.hledatZemi': '国を検索…',
  'svet.vsechnyZeme': 'すべての国',
  'svet.jenSObsahem': '内容がある国だけ',
  'svet.nicNenalezeno': '該当する国はありません。',
  'svet.zaznamu': (p) => `${p.pocet} 件`,
  'svet.prazdnaZeme': 'まだ何もありません',
  'svet.kontinent': '大陸',
  'svet.celySvet': '世界全体',
  'svet.vse': 'すべて',
  'svet.zacniDomovem': 'まずは自分が「ここが家」と思う国を選んでください。地図の下のリストからも選べます。',
  'svet.zkoumej': '国を選ぶと、Bloom にそこで何があるかが見られます。どこを見て回っても——'
      + 'あなたの居住国は変わりません。',
  'svet.domov': '拠点',
  'svet.zrusitDomov': '居住国の設定を消す',
  'svet.nastavitDomov': '居住国に設定する',
  'svet.zeSveta': '世界から',
  'svet.coSeChysta': 'これから',
  'svet.souteze': '応募受付中のコンテスト',
  'svet.noveOrganizace': '新しい団体',
  'svet.kdeJizNeco': 'Bloom にすでに何かある場所',
  'svet.hledatZemiPopisek': '国を検索',
  'svet.nicNeodpovida': '該当なし。別の言葉で試してください。',
  'svet.napovedaKMape': '地図はドラッグで動かし、ホイールかボタンで拡大縮小できます。使わなくても'
      + '大丈夫です——検索と国の一覧は下にあります。',
  'svet.tvujBloom': (p) => `${p.zeme}のあなたの Bloom`,
  'svet.tvojeDomovska': 'あなたの居住国',
  'svet.zemi': (p) => `${p.pocet} か国`,
  'svet.chyba': '国の一覧を読み込めませんでした。ページを再読み込みしてください。',
  'svet.pocet.specialists': (p) => `専門家 ${p.pocet} 人`,
  'svet.pocet.organizations': (p) => `団体 ${p.pocet} 件`,
  'svet.pocet.events': (p) => `イベント ${p.pocet} 件`,
  'svet.pocet.pageants': (p) => `コンテスト ${p.pocet} 件`,
  'svet.pocet.resources': (p) => `資料 ${p.pocet} 件`,

  // světadíly
  'kontinent.europe': 'ヨーロッパ',
  'kontinent.asia': 'アジア',
  'kontinent.africa': 'アフリカ',
  'kontinent.north_america': '北アメリカ',
  'kontinent.south_america': '南アメリカ',
  'kontinent.oceania': 'オセアニア',
  'kontinent.antarctica': '南極',

  // ── soutěže napříč světem ─────────────────────────────────────────────────
  'souteze.podtitulek': '世界じゅうのトランスコンテスト。まだ応募できるものが上に並びます。',
  'souteze.hledat': 'コンテストを検索…',
  'souteze.zadne': 'まだコンテストがありません。ご存じですか？ 教えてください。',

  // ── náhled země pod mapou ─────────────────────────────────────────────────
  'nahled.otevrit': (p) => `${p.zeme}を開く`,
  'nahled.zavrit': 'プレビューを閉じる',
  'nahled.jenInformace': '今のところ、この国についての情報しかありません。',
  'nahled.zatimNic': 'ここにはまだ連絡先も団体もイベントもありません。何かご存じですか？ 教えてください。',
  // ── stránka země ──────────────────────────────────────────────────────────
  'zeme.titulek': (p) => `${p.zeme}の Bloom`,
  'zeme.podtitulek': (p) => `${p.zeme}でコミュニティが集めてきたもの。`,
  'zeme.prazdna': 'Bloom はここではまだ始まったばかりです。最初に何かを足すのはあなたかもしれません。',
  'zeme.mapaSveta': '世界地図',
  'zeme.navrhnout': '情報を提案する',
  'zeme.domovska': 'あなたの居住国',
  'zeme.nastavitDomovskou': '居住国に設定する',
  'zeme.kdeToJe': '場所',
  'zeme.coTuBude': 'ここで見つかるもの',
  'zeme.zatimPrazdne': 'まだ空です',
  'zeme.pripravujeme': '準備中',
  'zeme.zobrazitVse': (p) => `すべて表示（${p.pocet}）`,
  'zeme.rosteTitulek': 'Bloom はここではまだ育っているところです',
  'zeme.rostePopis': 'ここにはまだ何もありません。団体やイベント、役に立つ'
      + '連絡先をご存じですか？ 教えてください——確認したうえでここに出ます。',
  'zeme.jinouZemi': 'ほかの国を見る',
  'zeme.bezKontaktu': 'ここにはまだ連絡先も団体もありません。',
  'zeme.bezKontaktuPopis': 'ここで誰か、あるいは役に立つ何かをご存じですか？ 教えてください——'
      + '確認したうえでここに出ます。',
  'zeme.neznama': 'その国はわかりません。',
  'zeme.chyba': 'この国を読み込めませんでした。',

  // ── sekce ─────────────────────────────────────────────────────────────────
  'sekce.specialists': '医師とクリニック',
  'sekce.specialists.popis': 'コミュニティに経験がある医師、クリニック、その他の専門家。',
  'sekce.organizations': '団体',
  'sekce.organizations.popis': '協会、非営利団体、サポートグループ。',
  'sekce.events': 'イベント',
  'sekce.events.popis': '集まり、プライド、ワークショップ、カンファレンス。',
  'sekce.pageants': 'コンテスト',
  'sekce.pageants.popis': 'トランスコンテストとその日程。',
  'sekce.resources': '資料',
  'sekce.resources.popis': 'この国での実用的な情報。',
  'sekce.community': 'コミュニティ',
  'sekce.community.popis': 'この国にいる人やグループ。',
  'sekce.legal': '法律の助け',
  'sekce.legal.popis': 'トランスコミュニティのための情報と支え',
  'sekce.support': '助け合い',
  'sekce.support.popis': '自分にできることを差し出し、ほかのメンバーから助けをもらう',

  // ── výpis záznamů ─────────────────────────────────────────────────────────
  'vypis.hledatVZemi': 'この国のなかで検索…',
  'vypis.vsechnyKategorie': 'すべてのカテゴリ',
  'vypis.kategorie': 'カテゴリ',
  'vypis.celaZeme': '国全体',
  'vypis.navrhnout': '提案する',
  'vypis.nicNeodpovida': '該当なし。別の言葉で試すか、絞り込みを外してください。',
  'vypis.zadneZaznamy': (p) => `${p.zeme}にはまだ登録がありません。`,
  'vypis.zaznamu': (p) => `${p.pocet} 件`,
  'vypis.predchozi': '前へ',
  'vypis.dalsi': '次へ',
  'vypis.chyba': '一覧を読み込めませんでした。',
  'vypis.neznamyDruh': 'その種類の登録はわかりません。',

  // ── detail záznamu ────────────────────────────────────────────────────────
  'detail.zpetNa': (p) => `${p.zeme}に戻る`,
  'detail.kontakty': '連絡先とリンク',
  'detail.podrobnosti': '詳細',
  'detail.zacatek': '開始',
  'detail.termin': '日程',
  'detail.uzaverka': '応募締切',
  'detail.prihlaska': '応募',
  'detail.strankaAkce': 'イベントのページ',
  'detail.web': 'ウェブサイト',
  'detail.konec': '終了',
  'detail.stavRocniku': '今回の状況',
  'detail.oblasti': '活動分野',
  'detail.coNabizi': '提供していること',
  'detail.kategorie': 'カテゴリ',
  'detail.jazyky': '言語',
  'detail.vitezove': 'これまでの優勝者',
  'detail.kdoSeMuze': '応募できる人',
  'detail.poradatel': '主催',
  'detail.poplatek': '参加費',
  'detail.tema': 'テーマ',
  'detail.forma.offline': '対面',
  'detail.forma.online': 'オンライン',
  'detail.forma.hybrid': '対面とオンライン',
  'detail.rozsah.local': '地域',
  'detail.rozsah.national': '全国',
  'detail.rozsah.international': '国際',
  'detail.rocnik.upcoming': '開催予定',
  'detail.rocnik.registration_open': '応募受付中',
  'detail.rocnik.registration_closed': '応募締切',
  'detail.rocnik.completed': '終了',
  'detail.zdroj': (p) => `出典：${p.zdroj}`,
  'detail.upraveno': (p) => `最終更新：${p.datum}`,
  'detail.overeno': '内容が正しいことを確認済みです。Bloom が推薦しているという意味ではありません。',
  'detail.neovereno': 'この情報はまだ確認されていません。内容が変わっている可能性があります——出典で確かめてください。',
  'detail.nenalezen': 'その情報はわかりません。削除されたか、まだ確認待ちかもしれません。',
  'detail.chyba': 'この情報を読み込めませんでした。',

  // ── profil země ───────────────────────────────────────────────────────────
  'profil.coTuPlati': 'ここでの決まり',
  'profil.name_change': '改名',
  'profil.gender_marker': '法的な性別の記載',
  'profil.surgery_required': '手術要件',
  'profil.healthcare': '医療へのアクセス',
  'profil.legal_protection': '差別からの保護',
  'profil.safety': '安全',
  'profil.stav.yes': 'あり',
  'profil.stav.limited': '一部',
  'profil.stav.no': 'なし',
  'profil.stav.unknown': '不明',
  'profil.zdroj': '出典',
  'profil.zdrojZRoku': (p) => `${p.rok} 年の出典`,
  'profil.overeno': (p) => `${p.datum} 確認`,
  'profil.zmena': '最近の変更',
  'profil.odKdy': (p) => `${p.datum} から有効`,
  'profil.doklady': '根拠',
  'profil.zakon': '法律または裁判所',
  'profil.upozorneni': 'これは法的な助言ではありません。法律は変わりますし、多くはあなた個人の'
      + '状況によります——これをもとに動く前に、出典やその国の'
      + '団体に確認してください。',

  // ── formulář návrhu ───────────────────────────────────────────────────────
  'navrh.titulek': (p) => `${p.druh}を提案${p.zeme ? ` — ${p.zeme}` : ''}`,
  'navrh.popisFormulare': '提案は Bloom に出る前に確認を通ります。知っていることだけ'
      + '書いてください——残りはこちらで補います。',
  'navrh.jednotne.organizations': '団体',
  'navrh.jednotne.events': 'イベント',
  'navrh.jednotne.pageants': 'コンテスト',
  'navrh.jednotne.resources': '資料',
  'navrh.popis.organizations': '協会、非営利団体、サポートグループ。',
  'navrh.popis.events': '集まり、プライド、ワークショップ、カンファレンス。',
  'navrh.popis.pageants': 'トランスコンテスト – 日程、応募、主催。',
  'navrh.popis.resources': '実用的な情報 – 医療、法律、書類、連絡先。',
  'navrh.nazev': '名称',
  'navrh.popisPole': '説明',
  'navrh.zeme': '国',
  'navrh.mesto': '市',
  'navrh.adresa': '住所',
  'navrh.web': 'ウェブサイト',
  'navrh.email': 'メールアドレス',
  'navrh.telefon': '電話',
  'navrh.odkudVis': 'どこで知りましたか',
  'navrh.odkudVisPriklad': '例：公式サイト、実際に行った…',
  'navrh.vyberte': '— 選択 —',
  'navrh.forma': '形式',
  'navrh.rozsah': '規模',
  'navrh.platiPro': '適用範囲',
  'navrh.platnost.global': '世界全体',
  'navrh.platnost.country': '国',
  'navrh.platnost.region': '地域',
  'navrh.platnost.city': '市',
  'navrh.odkazAkce': 'イベントのリンク',
  'navrh.odkazPrihlaska': '応募のリンク',
  'navrh.odkazy': 'リンク',
  'navrh.text': '本文',
  'navrh.odeslat': '提案を送る',
  'navrh.odesilam': '送信中…',
  'navrh.chyba': '提案を送れませんでした',
  'navrh.dikyTitulek': 'ありがとうございます、受け取りました',
  'navrh.dikyPopis': '提案を受け取りました。誰かが確認したうえで、Bloom に'
      + '出ます。自動で公開されるものはありません。',
  'navrh.zavrit': '閉じる',
  'navrh.seznamNapoveda': '複数ある場合はカンマで区切ってください。',

  // ── převzetí profilu ──────────────────────────────────────────────────────
  'prevzeti.patriVam': (p) => `この${p.druh}はあなたのものですか？`,
  'prevzeti.popis': 'このページを引き継いで、情報を最新に保てます。'
      + '申請はまず確認を通ります。',
  'prevzeti.tlacitko': 'このページを引き継ぐ',
  'prevzeti.spravujes': 'このページはあなたが管理しています。情報はいつでも直せます——変更はすぐ反映されます。',
  'prevzeti.upravit': '情報を編集',
  'prevzeti.spravujeSama': (p) => `このページは${p.druh}自身が管理しています。`,
  'prevzeti.ceka': '引き継ぎの申請を受け取り、確認しています。',
  'prevzeti.formulacTitulek': (p) => `ページの引き継ぎ — ${p.nazev}`,
  'prevzeti.formulacPopis': 'ページをお渡しする前に、あなたが本当にその団体の方かを'
      + '確かめる必要があります。申請は確認を通ります。すぐには何も変わりません。',
  'prevzeti.role': 'そこでのあなたの役割は？',
  'prevzeti.rolePriklad': '例：コーディネーター、協会の代表',
  'prevzeti.doklad': 'それをどう確かめられますか？',
  'prevzeti.dokladPriklad': '例：団体サイトの連絡先に名前がある。または公式アドレスから連絡する',
  'prevzeti.dokladNapoveda': 'あなたの名前が載っているページのリンクで十分です。'
      + 'または団体の公式アドレスからご連絡ください。',
  'prevzeti.kontakt': 'あなたの連絡先',
  'prevzeti.kontaktPriklad': 'メールまたは電話',
  'prevzeti.dalsi': 'そのほか',
  'prevzeti.nepovinne': '（任意）',
  'prevzeti.odeslat': '申請を送る',
  'prevzeti.odesilam': '送信中…',
  'prevzeti.vyplnObe': '役割と、それをどう確かめられるかを教えてください。',
  'prevzeti.prijato': 'ありがとうございます。申請を受け取りました。ご連絡します。',
  'prevzeti.chyba': '申請を送れませんでした。',
  'prevzeti.upravaTitulek': (p) => `ページを編集 — ${p.nazev}`,
  'prevzeti.upravaPopis': '名称と場所はあえてここにありません。検索や並べ替えに'
      + '使われているからです。変わった場合はご連絡ください、こちらで更新します。',
  'prevzeti.popisPole': '説明',
  'prevzeti.email': 'メールアドレス',
  'prevzeti.telefon': '電話',
  'prevzeti.web': 'ウェブサイト',
  'prevzeti.ulozeno': '保存しました。',
  'prevzeti.ukladam': '保存中…',
  'prevzeti.chybaUlozeni': '保存できませんでした。',
  'prevzeti.druh.organizations': '団体',
  'prevzeti.druh.events': 'イベント',
  'prevzeti.druh.pageants': 'コンテスト',
  // ── profil ────────────────────────────────────────────────────────────────
  'profil.upravteUdaje': 'プロフィールと設定を編集',
  'profil.overeny': '認証済み',
  'profil.neovereny': '未認証',
  'profil.overteEmail': 'メールアドレスを認証してください。未認証のアカウントは権限が限られます。',
  'profil.emailOdeslan': '認証メールを送りました。',
  'profil.emailChyba': 'メールを送れませんでした',
  'profil.odeslano': '送信しました。',
  'profil.overeniOdbornika': '専門家・弁護士としての認証',
  'profil.pracujeteVOboru': 'その分野で働いていますか？ 認証バッジを取得できます。',
  'profil.zadostOdeslana': '申請を送りました',
  'profil.pozadatOOvereni': '認証を申請する',
  'profil.zadostTitulek': '専門家・弁護士としての認証を申請',
  'profil.zadostPopis': '申請の内容を書いてください。モデレーターが確認します。',
  'profil.pozadovanaRole': '希望する立場',
  'profil.roleOdbornik': '専門家',
  'profil.rolePravnik': '弁護士',
  'profil.specializace': '専門',
  'profil.odkazNaProfil': '職業上のプロフィールのリンク',
  'profil.zpravaProAdmina': '管理者への短いメッセージ',
  'profil.odesilam': '送信中…',
  'profil.odeslatZadost': '認証の申請を送る',
  'profil.vyplnteSpecializaci': '専門を書いてください',
  'profil.zadostUspech': '認証の申請を送りました。',
  'profil.zadostChyba': '申請を送れませんでした',

  // bezpečnost
  'bezp.titulek': 'セキュリティ',
  'bezp.sifrovaniZapnuto': (p) => `メッセージの暗号化はオンです${p.odemceno ? '（解錠済み）' : '（このタブではロック中）'}。`,
  'bezp.sifrovaniVypnuto': 'メッセージの暗号化はまだオンになっていません。',
  'bezp.sifrovaniKde': 'オンにするのも解錠するのも「メッセージ」のページです。',
  'bezp.sifrovaniKdeVypnute': '「メッセージ」のページの、どの会話からでもオンにできます。',
  'bezp.zmenaHesla': 'パスワードの変更',
  'bezp.zmenaHeslaSifrovani': '暗号化がオンなので、パスワードを変えるとメッセージの鍵も包み直されます。'
      + 'そのために今のパスワードが要ります——それがないと鍵を開けられず、メッセージを失ってしまいます。',
  'bezp.stavajiciHeslo': '現在のパスワード',
  'bezp.noveHeslo': '新しいパスワード',
  'bezp.noveHesloZnovu': '新しいパスワードをもう一度',
  'bezp.pozadavky': '8文字以上、大文字と小文字、数字、記号をそれぞれ1つ。',
  'bezp.zmenitHeslo': 'パスワードを変更',
  'bezp.menim': '変更中…',
  'bezp.hesloNeshoda': '新しいパスワードが一致しません。',
  'bezp.vyplnObe': 'パスワードを両方とも入力してください。',
  'bezp.stareNesedi': '現在のパスワードが違います——メッセージの鍵を失うことになるので、何も変更していません。',
  'bezp.zmenenoSKlicem': 'パスワードを変更しました。メッセージの鍵は包み直したので、古いメッセージも読めます。',
  'bezp.zmeneno': 'パスワードを変更しました。',
  'bezp.zmenaChyba': 'パスワードを変更できませんでした。',
  'bezp.nepamatujes': '鍵のパスワードを思い出せませんか？',
  'bezp.zahoditPopis': '鍵を捨てて、やり直すこともできます。これまでに暗号化したメッセージは完全に失われます'
      + '——誰にも読めません、私たちにもです。だからこそ安全なのです。',
  'bezp.zahodit': '鍵を捨ててやり直す',
  'bezp.zahoditPotvrzeni': '本当に鍵を捨てますか？\n\nこれまでに暗号化したメッセージはすべて完全に失われます'
      + '——誰にも読めません、私たちにもです。暗号化をオンにしたときのパスワードを'
      + '思い出せない場合にだけ、これをしてください。',
  'bezp.klicSmazan': '鍵を削除しました。ページを再読み込みしてください。',
  'bezp.nepovedlo': 'うまくいきませんでした。',
  'bezp.prohlizecNeumi': 'このブラウザは Bloom が使う暗号化に対応していません。',

  'profil.mujProfil': 'マイプロフィール',
  'profil.specializacePriklad': '例：心理士、性科学医、弁護士…',
  'profil.zpravaPriklad': '例えば資格登録や診療所サイトへのリンクなど…',
  'profil.overeniUvod': 'Bloom で認証済みの専門家や弁護士になりたいですか？ 認証を申請してください。'
      + 'プロフィールは実際の職業と一致している必要があります。',

  'profil.oborPriklad': '例：形成外科、家族法…',
  'profil.nepovinnyText': '任意の補足…',
  // ── dvoufázové přihlášení ─────────────────────────────────────────────────
  'dvf.titulek': '2段階ログイン',
  'dvf.zapnuto': (p) => `オンです。バックアップコードはあと ${p.pocet} 個あります。`,
  'dvf.vypnuto': 'パスワードに加えて、スマホのアプリに出る6桁のコードも入力します。',
  'dvf.chraniA': 'これが守るのは',
  'dvf.chraniPrihlaseni': 'ログイン',
  'dvf.chraniB': 'です。パスワードを知っていても、あなたのスマホがなければ入れません。',
  'dvf.nechrani': '暗号化されたメッセージは守りません',
  'dvf.nechraniPopis': '——あれはあなた自身のブラウザで、あなたのパスワードで開くもので、サーバーは関わりません。',
  'dvf.ulozKody': 'この10個のバックアップコードを保存してください',
  'dvf.ulozKodyPopis1': 'それぞれ一度しか使えません。そしてスマホをなくしたとき、入る道はこれだけです。',
  'dvf.znovuNeukaze': '誰も二度とは見せてくれません',
  'dvf.ulozKodyPopis2': '——私たちが保存しているのはハッシュだけです。',
  'dvf.zkopirovat': 'コピー',
  'dvf.ulozilaJsem': '保存しました',
  'dvf.zkopirovano': 'コピーしました。',
  'dvf.kopieChyba': 'コピーできませんでした。手で書き写してください。',
  'dvf.zapnout': '2段階ログインをオンにする',
  'dvf.pripravuji': '準備中…',
  'dvf.nactiKod': 'このコードを認証アプリで読み取ってください——例えば Google Authenticator、Authy、1Password、Aegis。',
  'dvf.qrNejde': 'QR コードを読み取れませんか？',
  'dvf.zadejRucne': 'この鍵をアプリに手で入力してください：',
  'dvf.opisKod': 'アプリに出ているコードを入力',
  'dvf.zapnoutKratce': 'オンにする',
  'dvf.overuji': '確認中…',
  'dvf.noveKody': '新しいバックアップコード',
  'dvf.vypnout': 'オフにする',
  'dvf.noveKodyPopis': '新しい組が古いものに置き換わります——今のバックアップコードは使えなくなります。',
  'dvf.kodZAplikace': 'アプリのコード',
  'dvf.vygenerovat': '作成',
  'dvf.vypnutiPopis': 'オフにするにはパスワードと有効なコードの両方が必要です。どちらも意図してのことです。そうでなければ、開いたままのブラウザに触れる人が誰でも外せてしまいます。',
  'dvf.kodNeboZalozni': 'アプリのコード、またはバックアップコード',
  'dvf.vypinam': 'オフにしています…',
  'dvf.vypnoutCele': '2段階ログインをオフにする',
  'dvf.vypnuto2': '2段階ログインをオフにしました。',
  'dvf.kodNesedi': 'そのコードは違います。',
  'dvf.nepovedlo': 'うまくいきませんでした。',

  // ── formulář profilu ──────────────────────────────────────────────────────
  'pf.ulozeno': 'プロフィールを更新しました。',
  'pf.chyba': 'プロフィールを更新できませんでした',
  'pf.fotkaNahrana': '写真をアップロードしました。',
  'pf.fotkaChyba': '画像をアップロードできませんでした',
  'pf.fotkaVelka': '画像が大きすぎます（最大 5 MB）',
  'pf.oznameniUlozeno': '通知の設定を保存しました。',
  'pf.oznameniChyba': '設定を保存できませんでした',
  'pf.zruseno': 'プロフィールを削除しました',
  'pf.zruseniChyba': 'プロフィールを削除できませんでした',
  'pf.zruseniPotvrzeni': '本当にプロフィールを削除しますか？ 取り消せません。あなたのデータはすべて消えます。',
  'pf.urlFacebook': 'Facebook のアドレスは https:// で始めてください',
  'pf.urlInstagram': 'Instagram のアドレスは https:// で始めてください',
  'pf.urlLinkedin': 'LinkedIn のアドレスは https:// で始めてください',
  'pf.ukladam': '保存中…',
  'pf.ulozitOznameni': '通知の設定を保存',
  'pf.oznameniZpravy': '個人メッセージ',
  'pf.oznameniAdmin': '管理者からの新しいメッセージ',
  'pf.oznameniUzivatel': 'ほかのメンバーからの新しいメッセージ',
  'pf.oznameniPodpora': '「助け合い」の新しい投稿',
  'pf.oznameniNabidky': '募集と依頼',

  // odznaky
  'pf.odznakAdmin': '管理者',
  'pf.odznakPravnik': '弁護士',
  'pf.odznakSpecialista': '確認済みの専門家',
  'pf.odznakClen': '確認済みのコミュニティメンバー',
  'pf.odznakPomocnik': 'よく助けてくれる人',
  'pf.odznakDuveryhodny': '信頼されているメンバー',

  // ── galerie ───────────────────────────────────────────────────────────────
  'gal.pridano': '写真をギャラリーに追加しました。',
  'gal.smazano': '写真を削除しました',
  'gal.hesloKratke': 'ギャラリーのパスワードは4文字以上にしてください',
  'gal.nahraniChyba': '写真をアップロードできませんでした',
  'gal.mazaniChyba': '写真を削除できませんでした',
  'gal.souborVelky': 'ファイルが大きすぎます（最大 5 MB）',
  'gal.ulozitNastaveni': '設定を保存',
  'gal.soukromiGalerie': 'ギャラリーの公開設定',
  'gal.verejnaGalerie': '公開ギャラリー',
  'gal.hesloPopis': '見る人はこのパスワードを入力する必要があります。',
  'gal.pridat': '写真か動画を追加',
  'gal.prazdna': 'ギャラリーにはまだ写真がありません',

  // ── moje cesta ────────────────────────────────────────────────────────────
  'cesta.kdeJsem': '私は今どこ？',
  'cesta.popis': 'よければ自分の移行の段階を共有してください——自分だけにしておいても大丈夫です。',
  'cesta.soukroma': 'あなたの段階は非公開です',
  'cesta.viditelna': 'あなたの段階はほかの人に見えます',
  'cesta.jenTy': 'あなたの段階が見えるのはあなただけです',
  'cesta.mohouNajit': 'ほかの人は「似た段階の人を探す」からあなたを見つけられます',
  'cesta.poznamka': '自分用のメモ',
  'cesta.volitelna': '（任意）',
  'cesta.poznamkaPriklad': '共有したいこと、覚えておきたいこと…',
  'cesta.najitPodobne': '似た段階の人を探す',
  'cesta.hledam': '検索中…',
  'cesta.ulozit': '私の道のりを保存',
  'cesta.ulozeno': 'あなたの道のりを保存しました。',
  'cesta.vyberteFazi': '段階を1つ選んでください',
  'cesta.chyba': '保存できませんでした',

  'pf.socialniSite': 'SNS',
  'pf.avatarFoto': 'アバター / プロフィール写真',
  'pf.nahratProfilni': 'プロフィール写真をアップロード',
  'pf.zrusitProfil': 'プロフィールを削除',
  'pf.nastaveniOznameni': '通知の設定',
  'pf.nastaveniOznameniPopis': 'どんなことを知らせてほしいか選んでください。',
  'gal.overEmail': '写真をアップロードするには、まずメールアドレスを認証してください。',
  'cesta.coMeCeka': 'この先にあること',

  // ── zprávy ────────────────────────────────────────────────────────────────
  'zpr.titulek': 'メッセージ',
  'zpr.hledatUzivatele': 'メンバーを検索…',
  'zpr.zadneKonverzace': 'まだ会話はありません',
  'zpr.vyhledejteVyse': '上でメンバーを検索してください',
  'zpr.vyberteKonverzaci': '会話を選ぶか、メンバーを検索してください',
  'zpr.napisteZpravu': 'メッセージを書く…',
  'zpr.nahravam': '録音中…',
  'zpr.prilozitObrazek': '画像を添付',
  'zpr.hlasovaZprava': '音声メッセージ',
  'zpr.zastavitNahravani': '録音を止める',
  'zpr.obrazek': '画像',
  'zpr.overteEmail': 'メッセージを送るには、メールアドレスを認証してください。',
  'zpr.profil': 'プロフィール',

  // šifrování
  'zpr.sifrovanaZprava': '暗号化されたメッセージ',
  'zpr.odemkniNahore': '暗号化されたメッセージ——上でメッセージを解錠してください。',
  'zpr.nelzeOtevrit': 'この暗号化されたメッセージは開けませんでした。',

  // hlášky
  'zpr.uzivatelNenalezen': 'その人は見つかりません',
  'zpr.prijemceNenalezen': '宛先が見つかりません',
  'zpr.prihlasteZnovu': 'もう一度ログインしてください（セッションが切れました）',
  'zpr.serverNedostupny': 'サーバーにつながりません。バックエンドが動いているか確認してください。',
  'zpr.chybaOdeslani': '送信できませんでした',
  'zpr.souborVelky': 'ファイルが大きすぎます（最大 5 MB）',
  'zpr.formatNepodporovan': '対応していないファイル形式です',
  'zpr.mediaOdeslano': 'ファイルを送りました',
  'zpr.mikrofon': 'マイクが使えません',
  'zpr.hlasovkaOdeslana': '音声メッセージを送りました',
  'zpr.hlasovkaChyba': (p) => `音声メッセージを送れませんでした：${p.detail}`,
  'zpr.smazano': '会話を削除しました',
  'zpr.smazaniChyba': '会話を削除できませんでした',
  'zpr.smazaniPotvrzeni': 'あなたの一覧からは消えます。添付も一緒にです。相手の側には残ります——'
      + 'メッセージがサーバーから完全に消えるのは、二人とも削除したときです。',

  // ── šifrování zpráv ───────────────────────────────────────────────────────
  'sif.zadejHeslo': 'パスワードを入力してください。',
  'sif.zapnuto': '暗号化はオンです。',
  'sif.odemceno': 'メッセージを解錠しました。',
  'sif.hesloNesedi': 'そのパスワードは違います。',
  'sif.prohlizecNeumi': 'このブラウザは Bloom が使う暗号化に対応していません。書くことはできますが、'
      + 'エンドツーエンドでは暗号化されません。',
  'sif.noveJsouSifrovane': '新しいメッセージは暗号化されます。鍵を持っているのはあなただけです——サーバーには読めません。',
  'sif.odemkniZpravy': 'メッセージを解錠する',
  'sif.odemkniPopis': '鍵はこのタブのメモリにしかないので、ページを読み込み直すとまたパスワードが要ります。'
      + 'どこにも保存できません——保存できたら、それはもうあなただけが握る暗号化ではありません。',
  'sif.zapniSifrovani': 'メッセージの暗号化をオンにする',
  'sif.zapniPopis': '新しいメッセージはこの端末の中で暗号化されます。サーバーに届くのは意味のない文字列だけで、'
      + '中身は読めません——裁判所に求められてもです。',
  'sif.pozorA': '注意：鍵はあなたのパスワードで開きます。',
  'sif.pozorTucne': '忘れると、あなたの暗号化されたメッセージは誰にも読めません',
  'sif.pozorB': '——私たちにもです。それこそが要点ですが、つまりどこかに控えておく必要があります。',
  'sif.mobilA': 'オンにすると、ログインの仕方も変わります。パスワードはサーバーにまったく届かなくなり、そのハッシュだけが送られます。',
  'sif.mobilTucne': '古い Bloom のスマホアプリでは、このアカウントにログインできなくなります',
  'sif.mobilB': '——更新するまでは。ウェブではすべてこれまでどおり動きます。',
  'sif.zapnoutSifrovani': '暗号化をオンにする',
  'sif.odemknout': '解錠',
  'sif.tvojeHeslo': 'あなたの Bloom のパスワード',
  'sif.prilohaZamcena': '暗号化された添付——上でメッセージを解錠してください。',
  'sif.prilohaChyba': '添付を開けませんでした。',
  'sif.priloha': 'メッセージの添付',

  // ── v mém okolí ───────────────────────────────────────────────────────────
  'okoli.vaseLokalita': 'あなたの場所',
  'okoli.nastavtePolohu': '場所を設定すると、あなたに合った結果が出ます',
  'okoli.vyberteVyse': '上で場所を選ぶと、近くの募集や専門家が見られます',
  'okoli.zadniOdbornici': 'この地域にはまだ登録された専門家がいません',
  'okoli.zadneNabidky': 'この地域にはまだ募集がありません',
  'okoli.zadniClenove': 'この地域にはまだコミュニティのメンバーがいません',
  'okoli.vytvoritNabidku': '募集を作る',

  // ── hledání ───────────────────────────────────────────────────────────────
  'hled.hledam': '検索中：',
  'hled.vysledkyPro': '検索結果：',
  'hled.nicPro': '見つかりませんでした：',
  'hled.nicZkuste': '何も見つかりませんでした。別の言葉で試してください。',
  'hled.zkratte': '短い言い方や、別のキーワードで試してください。',
  'hled.zadejte': '探しているものを入力して Enter を押してください',
  'hled.priklady': '例：FFS、ホルモン、改名、医師、書類、手術…',
  'hled.uzivatele': 'メンバー',
  'hled.odbornici': 'トランスフレンドリーな専門家',
  'hled.clanky': '法律の助け – 記事',
  'hled.otazky': 'コミュニティの質問',
  'hled.nabidky': '助け合いの募集',
  'hled.prispevky': '投稿',
  'hled.recenze': '専門家へのレビュー',

  // ── profil člena ──────────────────────────────────────────────────────────
  'up.nenalezen': 'その人は見つかりません',
  'up.oMne': '紹介',
  'up.clenOd': '参加日',
  'up.odznakSpravce': '管理者',
  'up.odznakPravnik': '弁護士',
  'up.odznakOdbornik': '確認済みの専門家',
  'up.odznakPravnikOvereny': '確認済みの弁護士',
  'up.odznakClen': '確認済みのメンバー',
  'up.odznakPomocnik': 'よく助けてくれる人',
  'up.odznakDuveryhodny': '信頼されている',
  // ── zásady komunity ───────────────────────────────────────────────────────
  'kom.zpet': 'Bloom に戻る',
  'kom.oProjektu': 'Bloom は、チェコのトランスの人たちのための安全なコミュニティの場所として生まれました——'
      + '経験を分かち合い、支えを見つけ、専門家とつながり、人と出会うための場所です。'
      + 'このプロジェクトはコミュニティがボランティアで運営しています。目指すのは、慎重さ、プライバシー、そして助け合いです。',
  'kom.kontaktText': '質問がある、助けが必要——遠慮なくご連絡ください。できるだけ早く返します。',
  'kom.respekt': '私たちは互いを尊重します',
  'kom.respektPopis': '一人ひとりを、その人が使っている名前と代名詞で呼びます。それぞれ違う道と経験を尊重します'
      + '——トランスであることに、正しいやり方も間違ったやり方もありません。',
  'kom.soukromi': '私たちは互いのプライバシーを守ります',
  'kom.soukromiPopis': 'Bloom で共有されたことは Bloom のなかに留まります。ほかの人の情報を、その人の'
      + '同意なしに広めないでください。匿名でいることを尊重します。',
  'kom.pomahame': '私たちは互いに助け合います',
  'kom.pomahamePopis': 'Bloom は支え合いの場所です。経験を分かち合い、助け合い、つながりや情報を'
      + '探しているすべての人のために安全な場所をつくります。',
  'kom.obtezovani': '嫌がらせは許しません',
  'kom.obtezovaniPopis': '嫌がらせ、いじめ、敵意のある書き込みに、Bloom に居場所はありません。居心地が悪いと感じたら、'
      + '管理者に知らせてください。',
  'kom.spam': '宣伝やスパムはなしで',
  'kom.spamPopis': 'Bloom は売り買いの場ではありません。頼まれていない宣伝や商業的な内容は投稿しないでください。'
      + '募集や依頼は「助け合い」へどうぞ。',
  'kom.prostor': 'どの段階にも居場所があります',
  'kom.prostorPopis': '道のりのどこにいても、あなたは一人ではありません。移行を考えはじめた人、'
      + 'その途中の人、通り過ぎた人——どの道も、そのままの形で受け止めます。',
  'kom.dataPopis': 'Bloom が集めるのは、サービスを動かすのに必要なデータだけです：メールアドレス、ニックネーム、'
      + 'そしてあなた自身がつくったプロフィール。',
  'kom.dataTretiStrany': 'あなたのデータが第三者に渡ることはありません。追跡技術も広告ネットワークも使っていません。',
  'kom.dataSmazani': 'アカウントと、それに紐づくすべてのデータの削除を求める権利があります。管理者にご連絡ください。',

  'okoli.podtitulek': '近くのコミュニティメンバー、サービス、専門家を見つける',
  'okoli.cleneVOkoli': (p) => `${p.misto}の近くのコミュニティメンバー`,
  'okoli.nabidkyVOkoli': (p) => `${p.misto}の近くの助け合いの募集`,
  'okoli.odborniciVOkoli': (p) => `${p.misto}の近くの専門家`,
  'hled.zobrazitVice': 'もっと見る',
  'kom.titulek': 'コミュニティのルール',
  'kom.podtitulek': 'みんなのための安全な場所',
  'kom.jakNahlasit': '問題の知らせ方',
  'kom.jakNahlasitPopis': 'ふさわしくない行動に出会ったら、方法は二つあります。その人のプロフィールにある'
      + '「この人を報告」ボタンを使うか、管理者に書くかです。',
  'kom.duverne': '報告の内容は外に出しません。',
  'kom.ochranaSoukromi': 'プライバシー',
  'obecne.zpetKratce': '戻る',

  // ── průvodce fází ─────────────────────────────────────────────────────────
  'cesta.nikdoNesdili': 'この段階を公開しているメンバーは、まだほかにいません。',
  'cesta.poznamkaFazePriklad': 'この段階について、共有したいこと・覚えておきたいこと…',
  'pruvodce.fazeNenalezena': '段階が見つかりません',
  'pruvodce.pripravujeme': 'この部分はまだ準備中です。',
  'pruvodce.krokyJenTy': 'チェックした手順が見えるのはあなただけです。',
  'pruvodce.nastavitFazi': '今の私の段階にする',
  'pruvodce.fazeNastavena': '今のあなたの段階になっています',
  'pruvodce.chyba': '保存できませんでした。もう一度お試しください',
  'pruvodce.kroku': '個の手順',
  'pruvodce.odborniku': () => '人のこの段階に合う専門家',
  'pruvodce.pribehu': () => '件のこの段階の人の体験談',

  // ── obnovení hesla ────────────────────────────────────────────────────────
  'reset.titulek': 'パスワードの再設定',
  'reset.popis': 'Bloom のアカウントに新しいパスワードを設定してください。',
  'reset.noveHeslo': '新しいパスワード',
  'reset.noveHesloPriklad': '新しいパスワードを入力',
  'reset.potvrdit': '新しいパスワードの確認',
  'reset.nastavit': '新しいパスワードを設定',
  'reset.ukladam': '保存中…',
  'reset.hotovo': 'パスワードを変更しました。ログインできます。',
  'reset.neplatnyOdkaz': 'その再設定リンクは無効です。',
  'reset.odkazVyprsel': '再設定リンクの期限が切れているか、無効です。新しいものを申請してください。',
  'reset.chyba': 'パスワードを再設定できませんでした。',
  'reset.neshoda': 'パスワードが一致しません。',
  'reset.ztratiPristup': 'は読めなくなります',

  'cesta.volitelne': 'これはまったくの任意です。よければ自分の移行の段階を共有してください——自分だけにしておいても大丈夫です。'
      + '道のりの似た地点にいる人を見つけることもできます。',
  'cesta.hledatVeFazi': 'この段階の人を探す：',
  'cesta.jenVerejne': '（公開しているメンバーだけ）',
  'pruvodce.zpetNaCestu': '「私の道のり」に戻る',
  'pruvodce.tadyJsi': 'あなたは今ここ',
  'reset.prejitNaPrihlaseni': 'ログインへ',
  'reset.sifrovaniVarovani': 'メッセージの暗号化をオンにしている場合：パスワードを再設定すると、古い'
      + '暗号化されたメッセージには届かなくなります。その鍵は元のパスワードで開くもので、ここでは誰もそれを知らないので、'
      + '包み直せません。新しいメッセージは暗号化できますが、古いものは読めません——私たちにもです。',

  // ── veřejná úvodní stránka ────────────────────────────────────────────────
  'uvod.prihlasit': 'ログイン',
  'uvod.vytvoritUcet': 'アカウントを作る',
  'uvod.uzMamUcet': 'すでにアカウントを持っています',
  'uvod.nadpis': 'トランスコミュニティのための安全な場所',
  'uvod.podnadpis': 'Bloom は、率直に話し、トランスフレンドリーな専門家を見つけ、'
      + 'その感じを知っている人たちのあいだで移行を進められる、非公開の場所です。',
  'uvod.zdarma': '登録は無料です。Bloom の中身はログインしてから開きます。',
  'uvod.kCemuJe': 'Bloom は何のためにあるか',
  'uvod.kCemuJe1': 'チェコで移行についての情報を探すと、たいていは散らばったフォーラム、'
      + '古い記事、信じていいかわからないリンクをクリックして回ることになります。しかも多くの問いは、'
      + '実際に通ってきた人が答えるのがいちばんです。',
  'uvod.kCemuJe2': 'Bloom はそれを一つの場所にまとめます。コミュニティで評判のいい専門家、'
      + '移行の各段階を通るガイド、法律の助け、そして何より、話しかけられる人たちを。',
  'uvod.kCemuJe3': 'そして、こうしたことはインターネット全体に言いたいことではないので、Bloom は'
      + '最初から、外からは何も見えないように作られています。',
  'uvod.coNajdes': 'Bloom で見つかるもの',
  'uvod.coNajdesPopis': '互いにつながる8つの部分——実際に役立つ助けから、分かち合われた経験まで。',
  'uvod.soukromiZaklad': 'プライバシーは付け足しではなく、土台です',
  'uvod.jakZabezpeceny': 'Bloom はどう守られているか',
  'uvod.zabezpeceniPopis': 'メンバーのデータを売ることも、どこかで分析することもありません。Bloom には広告や解析の追跡が'
      + 'ありません——外部のスクリプトがあなたについて何かを知ることはありません。',
  'uvod.coNeumi': 'Bloom にできないこと',
  'uvod.metadataTucne': '誰がいつ誰に書いたか',
  'uvod.coNeumiA': 'サーバーはいつも',
  'uvod.coNeumiB': 'を知っています——それがなければメッセージを届けられません。エンドツーエンド暗号化でも'
      + 'このメタデータは隠せませんし、Signal でも同じです。プロフィールは暗号化できません。サーバーが'
      + 'ほかの人に見せなければならないからです。そして Bloom はウェブアプリなので、開くたびに'
      + '私たちのサーバーから暗号化のコードを読み込みます——サーバーを乗っ取った人は、理論上は書き換えたものを配れます。'
      + 'それを防げるのはストアの署名付きアプリだけです。',
  'uvod.pridejSe': '参加する',
  'uvod.pridejSePopis': 'ニックネームとメールアドレスがあれば十分です——戸籍上の名前をどこかに書く必要はありません。自分について'
      + '何を書くかはあなた次第で、いつでも変えたり消したりできます。',

  // co Bloom nabízí
  'uvod.karta.podpora': '助けを差し出す、あるいは頼む——診察に付き添う、服を貸す、'
      + '「誰かと話したい」まで。',
  'uvod.karta.odbornici': '性科学、内分泌、外科、心理療法、そして美容院まで。地図、連絡先、ほかの人の経験つきで。',
  'uvod.karta.pravo': '改名、公的な書類、仕事、学校。事情をよく知る人が答えます。',
  'uvod.karta.pruvodce': '一つひとつの段階に何があるか——最初の疑問から手術まで。確認済みの出典と専門家へのリンクつき。',
  'uvod.karta.zpravy': 'コミュニティの誰にでも書けます。メッセージと添付はサーバー上で暗号化して保存されます。',
  'uvod.karta.zkusenosti': '実際に通ってきた人たちの本当の話。検閲も、きれいごとの飾りもなしで。',
  'uvod.karta.aktuality': 'チェコのトランスをめぐって何が起きているか——法律の変化、イベント、コミュニティのニュース。',
  'uvod.karta.okoli': '近くに誰がいるか。小さな町にいても、一人ではないとわかるように。',

  // zabezpečení
  'uvod.bezp.zvencinic': '外からは何も見えません',
  'uvod.bezp.zvencinicText': 'プロフィール、体験談、写真、募集、投稿の画像は、すべてログインが必要です。アカウントがなければ、'
      + 'サーバーはメンバーについての情報を一切渡しません——検索エンジンにもです。',
  'uvod.bezp.hesla': 'あなたのパスワードは誰も知りません',
  'uvod.bezp.heslaText': '保存されるのは bcrypt のハッシュだけで、そこから元のパスワードは計算できません。'
      + '管理者でさえあなたのパスワードは見えず、送ることもできません——できるのは、新しく設定させることだけです。',
  'uvod.bezp.sifrovani': 'あなたから相手まで、暗号化されたメッセージ',
  'uvod.bezp.sifrovaniText': 'エンドツーエンド暗号化をオンにすると、本文と添付はあなた自身のブラウザで暗号化されます。'
      + '鍵はあなたのパスワードで開き、端末から出ることはありません——サーバーに届くのは'
      + '意味のない文字列だけで、読めません。裁判所に求められてもです。暗号化しない場合でも、メッセージは少なくとも'
      + 'サーバーのディスク上で暗号化されています。',
  'uvod.bezp.kontakty': 'あなたの連絡先はあなたのものです',
  'uvod.bezp.kontaktyText': 'メールアドレスと電話番号がほかのメンバーに渡ることはありません。移行の段階は、自分で公開するまで'
      + '非公開です——ガイドでチェックした手順も、見えるのはあなただけです。',
  'uvod.bezp.smazane': '削除は本当に削除です',
  'uvod.bezp.smazaneText': '会話はいつでも削除できます。両方が削除すると、添付も含めてサーバーから'
      + '永久に消えます。',
  'uvod.bezp.server': 'ヨーロッパの自前のサーバー',
  'uvod.bezp.serverText': 'Bloom は EU 内の自前のサーバーで、HTTPS だけで動いています。データベースには'
      + 'インターネットから届きません。バックアップは暗号化して別の保管先へ送られ、復元も試験済みです。',

  'uvod.karta.pruvodceNazev': '移行のガイド',
  'uvod.karta.zpravyNazev': '個人メッセージ',
  // ── vzájemná podpora ──────────────────────────────────────────────────────
  'pod.podtitulek': '自分にできることを差し出し、ほかのメンバーから助けをもらう',
  'pod.vse': 'すべて',
  'pod.nabidky': '提供',
  'pod.poptavky': '募集',
  'pod.nabidka': '提供',
  'pod.poptavka': '募集',
  'pod.celaCR': 'チェコ全体',
  'pod.celySvet': '世界全体',
  'pod.cesko': 'チェコ',
  'pod.svet': '世界',
  'pod.vsechnyTypy': 'すべてのカテゴリ',
  'pod.moje': (p) => `自分のもの（${p.pocet}）`,
  'pod.pridat': '追加',
  'pod.overEmail': 'メールアドレスを認証すると投稿できます',
  'pod.novaPoptavka': '新しい募集',
  'pod.novaNabidka': '新しい提供',
  'pod.popisPoptavky': '探しているものと、代わりに差し出せるものを書いてください。',
  'pod.popisNabidky': '自分にできることを、ほかのメンバーに差し出してください。',
  'pod.typPrispevku': '投稿の種類',
  'pod.volitelne': '（任意）',
  'pod.coNabizim': 'できること',
  'pod.coNabizimP': 'できること *',
  'pod.coHledamP': '探しているもの *',
  'pod.coHledamVymenou': '代わりに欲しいもの',
  'pod.priklOffer': '例：料理、ヘアカット、翻訳…',
  'pod.priklNeed': '例：マッサージ、写真撮影…',
  'pod.poptavkaSeZobrazi': 'あなたの募集は「募集」タブに出ます。',
  'pod.nabidkaSeZobrazi': 'ここを書くと、あなたの提供も「募集」タブに出ます。',
  'pod.popis': '説明',
  'pod.popisPriklad': 'もう少し詳しい説明…',
  'pod.oblast': '地域',
  'pod.lokalita': '場所',
  'pod.nechciUvadet': '書きたくない',
  'pod.kategorie': 'カテゴリ',
  'pod.ostatni': 'その他',
  'pod.pridatPoptavku': '募集を出す',
  'pod.pridatNabidku': '提供を出す',
  'pod.odpovedetNaPrispevek': '投稿に返信',
  'pod.napisteAutorovi': '投稿した人に個人メッセージを送ります。',
  'pod.od': (p) => `差出人：${p.kdo}`,
  'pod.odeslatZpravu': 'メッセージを送る',
  'pod.konceptOdpovedi': (p) => `こんにちは！ あなたの${p.co}「${p.nazev}」に興味があります。`,
  'pod.konceptPoptavka': '募集',
  'pod.konceptNabidka': '提供',
  'pod.zadneMoje': 'まだ投稿はありません',
  'pod.zadneNalezeny': '投稿は見つかりませんでした',
  'pod.vytvortePrvni': '最初の提供か募集を出してみましょう',
  'pod.zkusteFiltry': '絞り込みを変えるか、新しく投稿してみてください',
  'pod.expirovano': '期限切れ',
  'pod.hledam': '探しています',
  'pod.hledamCo': (p) => `探しています：${p.co}`,
  'pod.nabizimCo': (p) => `できます：${p.co}`,
  'pod.expirovala': 'この投稿は期限が切れています。更新したい場合は管理者にご連絡ください。',
  'pod.odpovedet': '返信',
  'pod.upravitPrispevek': '投稿を編集',
  'pod.upravtePrispevek': '自分の提供や募集を編集します。',
  'pod.nabizimP': 'できること *',
  'pod.hledamPotrebuji': '探している / 必要としている',
  'pod.coNabizitePriklad': 'できることは…',
  'pod.coHledatePriklad': '探しているものは…',
  'pod.ulozitZmeny': '変更を保存',
  'pod.vytvorenoPoptavka': '募集を出しました。',
  'pod.vytvorenoNabidka': '提供を出しました。',
  'pod.chybaVytvorit': '投稿を作れませんでした',
  'pod.opravduSmazat': 'この投稿を削除しますか？',
  'pod.smazano': '削除しました',
  'pod.chybaSmazat': '削除できませんでした',
  'pod.aktualizovano': '投稿を更新しました。',
  'pod.chybaUlozit': '保存できませんでした',
  'pod.zpravaOdeslana': 'メッセージを送りました。',
  'pod.chybaOdeslat': 'メッセージを送れませんでした',
  'obecne.hledatPriklad': '検索…',
  'obecne.upravit': '編集',

  // ── odborníci ─────────────────────────────────────────────────────────────
  'odb.podtitulek': 'あなたの道のりを助けてくれる、確認済みの専門家を見つける',
  'odb.hledatPriklad': '名前や市で検索…',
  'odb.vsechnyObory': 'すべての分野',
  'odb.radit': '並べ替え：',
  'odb.vychozi': '標準',
  'odb.nejvyssiHodnoceni': '★ 評価の高い順',
  'odb.nejnizsiHodnoceni': '★ 評価の低い順',
  'odb.zadniNalezeni': '専門家は見つかりませんでした',
  'odb.zkusteFiltry': '絞り込みを変えてみてください',
  'odb.recenzi': () => '件のレビュー',
  'odb.dostupnyV': '対応地域：',
  'odb.otevritVMapach': '地図で開く',
  'odb.pridatRecenzi': 'レビューを書く',
  'odb.ohodnotte': 'この専門家との経験を評価してください。',
  'odb.vaseHodnoceni': 'あなたの評価 *',
  'odb.popisZkusenosti': '経験を書いてください',
  'odb.popisteZkusenost': '経験を書いてください…',
  'odb.odeslatRecenzi': 'レビューを送る',
  'odb.recenze': (p) => `レビュー（${p.pocet}）`,
  'odb.zadneRecenze': 'まだレビューはありません。最初の一人になってください。',
  'odb.vyberteOdbornika': '専門家を選ぶと、詳細と地図が見られます',
  'odb.pridatOdbornika': '専門家を追加',
  'odb.pridejteOdbornika': '確認済みの専門家を新しく一覧に追加します。',
  'odb.navrhnout': '専門家を提案',
  'odb.navrhnetePopis': '管理者の承認を受ける専門家を提案します。',
  'odb.navrhVysvetleni': '提案は管理者に送られます。承認されると一覧に出ます。',
  'odb.overEmail': 'メールアドレスを認証すると専門家を提案できます',
  'odb.jmeno': '名前 *',
  'odb.kategorie': 'カテゴリ *',
  'odb.popis': '説明',
  'odb.popisPriklad': '専門、経験…',
  'odb.adresa': '住所 *',
  'odb.mesto': '市 *',
  'odb.kraj': '地域',
  'odb.vyber': '選択',
  'odb.stat': '国',
  'odb.cesko': 'チェコ',
  'odb.telefon': '電話',
  'odb.web': 'ウェブサイト',
  'odb.odesilam': '送信中…',
  'odb.odeslatKeSchvaleni': '承認へ送る',
  'odb.recenzePridana': 'レビューを追加しました。',
  'odb.chybaRecenze': 'レビューを追加できませんでした',
  'odb.odeslanKeSchvaleni': '専門家を承認へ送りました。',
  'odb.chybaOdeslat': '送れませんでした',
  'odb.pridan': '専門家を追加しました。',
  'odb.chybaPridat': '追加できませんでした',
  'odb.polozitOtazku': '質問する',
  'odb.novaOtazka': '専門家への新しい質問',
  'odb.naCoSeZeptat': '専門家に何を聞きたいですか？',

  // ── právní poradna ────────────────────────────────────────────────────────
  'prav.podtitulek': 'トランスコミュニティのための情報と支え',
  'prav.zpetNaPoradnu': '「法律の助け」に戻る',
  'prav.clankyAPruvodci': '記事とガイド',
  'prav.pridatClanek': '記事を追加',
  'prav.novyClanek': '新しい記事',
  'prav.vytvorteClanek': '法律のセクションに新しい記事を書きます。',
  'prav.nazev': 'タイトル *',
  'prav.kategorie': 'カテゴリ',
  'prav.publikovatIhned': 'すぐに公開',
  'prav.publikovano': '公開中',
  'prav.obsah': '本文 *',
  'prav.obsahPriklad': '記事の本文…',
  'prav.zadneClanky': 'このカテゴリには記事がありません',
  'prav.skryto': '非表示',
  'prav.skryt': '非表示にする',
  'prav.publikovat': '公開',
  'prav.upravitClanek': '記事を編集',
  'prav.upravteObsah': 'この記事の内容を編集します。',
  'prav.clanekPridan': '記事を追加しました。',
  'prav.chybaPridat': '記事を追加できませんでした',
  'prav.clanekUpraven': '記事を更新しました。',
  'prav.opravduSmazat': 'この記事を削除しますか？',
  'prav.chybaStav': '状態を変更できませんでした',
  'prav.pridatOtazku': '質問を追加',
  'prav.novaOtazka': '新しい質問',
  'prav.naCoSeZeptat': '何を聞きたいですか？',
  'obecne.vse': 'すべて',

  // ── aktuality ─────────────────────────────────────────────────────────────
  'akt.podtitulek': 'トランスの世界からのニュース',
  'akt.prehratVideo': '動画を再生',
  'akt.obrazekVClanku': '記事の中の画像',
  'akt.clanekNenalezen': '記事が見つかりません',
  'akt.zpetNaAktuality': 'ニュースに戻る',
  'akt.autor': (p) => `著者：${p.kdo}`,
  'akt.osobniPribeh': '個人の体験談',
  'akt.upravitClanek': '記事を編集',
  'akt.komentare': (p) => `コメント（${p.pocet}）`,
  'akt.zadneKomentare': 'まだコメントはありません。最初の一人になってください。',
  'akt.pridatKomentar': 'コメントを書く…',
  'akt.proKomentovaniOverte': 'メールアドレスを認証するとコメントできます。',
  'akt.profil': 'プロフィール',
  'akt.prihlasteSeProKomentovani': 'コメントするにはログインしてください。',
  'akt.upravteObsah': 'この記事の内容を編集します。',
  'akt.nadpisP': '見出し *',
  'akt.nadpis': '見出し',
  'akt.obsahP': '本文 *',
  'akt.textClanku': '記事の本文…',
  'akt.obrazekUrlNeboSoubor': '画像（URL またはファイル）',
  'akt.videoUrlNeboSoubor': '動画（URL またはファイル）',
  'akt.ukladam': '保存中…',
  'akt.novaAktualita': '新しい記事',
  'akt.sdiletPribeh': '体験談を共有',
  'akt.vytvoritAktualitu': '記事を書く',
  'akt.sdiletZkusenost': '経験を共有',
  'akt.napisteAktualitu': 'コミュニティに向けて新しい記事を書きます。',
  'akt.podelteSe': '自分の経験をコミュニティと分かち合います。',
  'akt.obrazek': '画像',
  'akt.nahratObrazek': '画像をアップロード…',
  'akt.nahratVideo': '動画をアップロード…',
  'akt.neboUrl': 'または URL：',
  'akt.textAktuality': '記事の本文…',
  'akt.sdilejtePribeh': '自分の体験や経験をコミュニティと分かち合う…',
  'akt.nahravam': 'アップロード中…',
  'akt.publikovat': '公開',
  'akt.zkusenostiTucne': 'コミュニティのメンバーの個人的な経験。',
  'akt.zkusenostiPopis': 'このセクションは、暮らしのなかの経験や体験談を分かち合う場所です。投稿には文章、画像、動画を入れられます。',
  'akt.sdiletSvujPribeh': '自分の体験談を共有する',
  'akt.zadneAktuality': 'ニュースはありません',
  'akt.zadneVKategorii': 'このカテゴリにはまだ何もありません',
  'akt.publikovan': '投稿を公開しました。',
  'akt.chybaPublikovat': '公開できませんでした',
  'akt.opravduSmazat': 'この投稿を削除しますか？',
  'akt.chyba': '何かがうまくいきませんでした',
  'akt.chybaKomentar': 'コメントを追加できませんでした',
  'akt.chybaSmazatKomentar': 'コメントを削除できませんでした',
  'akt.aktualizovan': '投稿を更新しました。',
  'obecne.smazat': '削除',

  // ── fáze tranzice ─────────────────────────────────────────────────────────
  'faze.thinking': '移行について考えている',
  'faze.thinking.popis': '自分が誰なのか、どの道が自分のものかを探っています。',
  'faze.research': '情報を探している',
  'faze.research.popis': '読んで、聞いて、情報源やコミュニティを探しています。',
  'faze.therapist': '初めてのセラピスト',
  'faze.therapist.popis': '自分の道について専門家と話しています。',
  'faze.hormones': 'ホルモン療法',
  'faze.hormones.popis': 'ホルモン療法を始めた、または続けています。',
  'faze.documents': '書類の変更',
  'faze.documents.popis': '名前や性別の法的な変更を進めています。',
  'faze.cosmetic': '見た目とお手入れ',
  'faze.cosmetic.popis': '見た目を整えています——髪、メイク、スタイル。',
  'faze.surgery-thinking': '手術を考えている',
  'faze.surgery-thinking.popis': '手術の選択肢を検討しています。',
  'faze.surgery': '手術のあと',
  'faze.surgery.popis': '一度、あるいは複数回の手術を受けました。',
  'faze.stable': '落ち着いた段階',
  'faze.stable.popis': 'いたい場所にいて、自分の暮らしを送っています。',
  'faze.individual': '自分だけの道',
  'faze.individual.popis': '私の道はどの枠にも入りません——それでいいのです。',

  // ── zkušenosti komunity ───────────────────────────────────────────────────
  'zk.podtitulek': 'ここが体験談を分かち合う場所です。',
  'zk.pribehNenalezen': '体験談が見つかりません',
  'zk.zpetNaPribehy': '体験談に戻る',
  'zk.komunita': 'コミュニティ',
  'zk.pribeh': '体験談',
  'zk.upravitPribeh': '体験談を編集',
  'zk.upravtePribeh': '共有した体験談を編集します。',
  'zk.textPribehu': '体験談の本文…',
  'zk.fazeTranzice': '移行の段階',
  'zk.neuvadet': '書かない',
  'zk.ukazeSeLidem': 'この体験談は、その段階のガイドを読んでいる人に表示されます。',
  'zk.sdiletPribeh': '体験談を共有',
  'zk.overEmail': 'メールアドレスを認証すると体験談を共有できます',
  'zk.zadnePribehy': 'まだ体験談はありません。最初の一人になってください。',
  'zk.nazevPribehu': '体験談のタイトル…',
  'zk.pribehP': '体験談 *',
  'zk.sdilejteZkusenost': '自分の経験をコミュニティと分かち合う…',
  'zk.chybaNacist': '体験談を読み込めませんでした',
  'zk.vyplnteNadpis': '見出しと本文を書いてください',
  'zk.spatnyOdkaz': '画像のリンクは http://、https:// または / で始めてください',
  'zk.sdilen': '体験談を共有しました。',
  'zk.chybaSdilet': '共有できませんでした',
  'zk.opravduSmazat': 'この体験談を削除しますか？',
  'zk.smazan': '体験談を削除しました',
  'zk.aktualizovan': '体験談を更新しました。',

  // ── rám aplikace ──────────────────────────────────────────────────────────
  'ram.emailNeoveren': 'メールアドレスがまだ認証されていません。認証してください。',
  'ram.odesilam': '送信中…',
  'ram.znovuOdeslat': 'もう一度送る',
  'ram.chceteUpozorneni': '新しいメッセージの通知を受け取りますか？',
  'ram.tedNe': '今はいい',
  'ram.paticka': '© 2026 Bloom – トランスコミュニティのための非公開の場所',
  'ram.zasadyKomunity': 'コミュニティのルール',
  'ram.prekladNeovereny': 'この翻訳は、まだこの言語を話す人が読んでいません。おかしなところがあれば教えてください。',
  'ram.nahlasitProblem': '問題を報告',

  // ── otázky komunity ───────────────────────────────────────────────────────
  'ot.spravce': '管理者',
  'ot.overenyPravnik': '確認済みの弁護士',
  'ot.overenyOdbornik': '確認済みの専門家',
  'ot.odznakJinaZeme': (p) => `このバッジが有効なのは：${p.zeme}`,
  'ot.otazkyKomunity': 'コミュニティの質問',
  'ot.pridatOtazku': '質問を追加',
  'ot.novaOtazka': '新しい質問',
  'ot.naCoSeZeptat': '何を聞きたいですか？',
  'ot.otazkaSeZobrazi': 'あなたの質問はほかのメンバーに表示され、答えてもらえます。',
  'ot.otazkaP': '質問 *',
  'ot.oblastTema': '分野 / テーマ',
  'ot.vseObecna': 'なんでも（一般的な質問）',
  'ot.odeslatOtazku': '質問を送る',
  'ot.overEmail': 'メールアドレスを認証すると質問できます',
  'ot.zadneOtazky': 'まだ質問はありません。最初の一人になってください。',
  'ot.hlasu': () => '票',
  'ot.odpovedi': () => '件の回答',
  'ot.zadneOdpovedi': 'まだ回答はありません。',
  'ot.napisteOdpoved': '回答を書く…',
  'ot.jenPravnici': '「法律の助け」の質問には、確認済みの弁護士と管理者が答えます。',
  'ot.smazatOtazku': 'この質問を削除しますか？',

  // ── cizí profil: nabídky, galerie, nahlášení ──────────────────────────────
  'cp.nabidkyAPoptavky': '提供と募集',
  'cp.zadneNabidky': '投稿はありません',
  'cp.napsatZpravu': 'メッセージを書く',
  'cp.nahlasitUzivatele': 'この人を報告',
  'cp.nahlasitKoho': (p) => `${p.kdo}を報告`,
  'cp.popisteDuvod': 'なぜ報告するのかを書いてください。管理者が見ます。',
  'cp.zustaneteAnonymni': '報告は管理者に届きます。あなたは匿名のままです。',
  'cp.duvodP': '理由 *',
  'cp.vybertDuvod': '理由を選ぶ…',
  'cp.nevhodneChovani': 'ふさわしくない行動',
  'cp.falesnyProfil': '偽のプロフィール',
  'cp.jinyProblem': 'そのほかの問題',
  'cp.popisVolitelny': '説明',
  'cp.volitelny': '（任意）',
  'cp.popisteSituaci': '状況をもう少し詳しく…',
  'cp.odeslatNahlaseni': '報告を送る',
  'cp.vyberteDuvodChyba': '報告の理由を選んでください',
  'cp.nahlaseniOdeslano': '報告を管理者に送りました',
  'cp.chybaNahlaseni': '報告を送れませんでした',
  'gal.chranenoHeslem': 'パスワードで保護',
  'gal.soukromi': '公開設定',
  'gal.nahravam': 'アップロード中…',
  'gal.pridatFotku': '写真を追加',
  'gal.nastaveniSoukromi': 'ギャラリーの公開設定',
  'gal.verejna': '公開',
  'gal.chranenaHeslem': 'パスワードで保護',
  'gal.jeChranena': 'このギャラリーはパスワードで保護されています',
  'gal.zadneFotky': 'まだ写真がありません。最初の一枚を追加してください。',
  'gal.otagovat': 'メンバーをタグ付け',
  'gal.hledatUzivatele': 'メンバーを検索…',
  'gal.odemcena': 'ギャラリーを解錠しました',
  'gal.spatneHeslo': 'ギャラリーのパスワードが違います',
  'gal.nastaveniUlozeno': 'ギャラリーの設定を保存しました',
  'gal.fotkaNahrana': '写真をアップロードしました。',
  'gal.chybaNahrat': '写真をアップロードできませんでした',
  'gal.fotkaSmazana': '写真を削除しました',
  'gal.jizOtagovan': 'その人はもうタグ付けされています',
  'gal.otagovan': (p) => `タグ付け：${p.kdo}`,
  'gal.chybaTag': 'タグを追加できませんでした',

  'ram.povolit': '許可する',
  'ram.oProjektu': 'このプロジェクトについて',
  'ram.kontakt': '連絡先',

  // ── mapa světa a počty obsahu ─────────────────────────────────────────────
  'mapa.popis': '世界地図 – 国をクリックすると開きます',
  'mapa.priblizit': '拡大',
  'mapa.oddalit': '縮小',
  'mapa.celySvet': '世界全体に戻る',
  'mapa.chybaNacteni': '地図を読み込めませんでした',
  'mapa.chybaZkusteSeznam': '地図を読み込めませんでした。下の国の一覧をお使いください。',
  'mapa.teprveRoste': 'Bloom はここではまだ始まったばかりです',
  'mapa.napovedaDotyk': 'ドラッグで地図を動かし、二本指・ダブルタップ・ボタンのどれでもズームできます。使わなくても大丈夫です——下に検索と国の一覧があります。',
  'obsah.specialists': () => '人の専門家',
  'obsah.organizations': () => '件の団体',
  'obsah.events': () => '件のイベント',
  'obsah.pageants': () => '件のコンテスト',
  'obsah.resources': () => '件の資料',
  'obsah.zaznamu': (p) => `${p.pocet} 件`,

  // ── výběr domovské země ───────────────────────────────────────────────────
  'domov.otazka': 'あなたの拠点はどこですか？',
  'domov.popis': 'そうすると Bloom は近くのものを見せます。どの国を見て回っても、居住国は変わりません。'
      + 'これはどこにも公開されませんし、いつでも変えられます。',
  'domov.preskocit': 'スキップ',
  'domov.najitZemi': '国を探す…',
  'domov.nicNeodpovida': '該当なし。別の言葉で試してください。',
  'domov.klikniDoMapy': '上の地図で国をクリックしても選べます。',

  // ── vyhledávání v liště ───────────────────────────────────────────────────
  'typ.posts': '投稿',
  'typ.users': 'メンバー',
  'typ.specialists': '専門家',
  'typ.services': '募集',
  'typ.articles': '法律の助け',
  'typ.questions': 'コミュニティの質問',
  'typ.reviews': '専門家へのレビュー',
  'nav.emailNeoveren': 'メール未認証',
  'nav.neovereny': '未認証',

  // ── hlášení problému ──────────────────────────────────────────────────────
  'chyba.neco': '何かが動きません',
  'chyba.navrh': '改善の提案',
  'chyba.bezpecnost': 'セキュリティの問題',
  'chyba.jiny': 'そのほか',
  'chyba.vyberteTyp': '問題の種類を選んでください',
  'chyba.popisteProsim': '問題の内容を書いてください',
  'chyba.odeslano': '報告を送りました。ありがとうございます。',
  'chyba.chybaOdeslat': '報告を送れませんでした',
  'chyba.napisteNam': '何が起きたか教えてください——直すのに役立ちます。',
  'chyba.typProblemu': '問題の種類',
  'chyba.popisProblemu': '何が起きたか',
  'chyba.popisPriklad': '何が起きたか、何を期待していたか、代わりに何が起きたかを書いてください…',
  'chyba.priloha': '自動で添えるもの：今のページ、時刻、あなたのブラウザの情報。',
  'chyba.odeslatHlaseni': '報告を送る',

  // ── editor textu ──────────────────────────────────────────────────────────
  'ed.napisteObsah': '内容を書く…',
  'ed.tucne': '太字（Ctrl+B）',
  'ed.kurziva': '斜体（Ctrl+I）',
  'ed.odrazky': '箇条書き',
  'ed.vlozitOdkaz': 'リンクを挿入',
  'ed.vlozitTabulku': '表を挿入',
  'ed.radky': '行',
  'ed.sloupce': '列',
  'ed.vlozit': '挿入',
  'ed.barva.cerna': '黒',
  'ed.barva.seda': 'グレー',
  'ed.barva.fialova': '紫',
  'ed.barva.ruzova': 'ピンク',
  'ed.barva.modra': '青',
  'ed.barva.zelena': '緑',
  'ed.barva.cervena': '赤',
  'ed.barva.oranzova': 'オレンジ',

  // ── ověření e-mailu a přihlášení přes jiné služby ─────────────────────────
  'over.neplatnyOdkaz': 'その認証リンクは無効です。',
  'over.hotovo': 'メールアドレスを認証しました。',
  'over.odkazVyprsel': '認証リンクが無効か、期限が切れています。',
  'over.overuji': 'メールアドレスを認証しています…',
  'over.cekejte': '少しお待ちください。',
  'over.overen': 'メールアドレスを認証しました。',
  'over.plnyPristup': 'これで Bloom のすべてを使えます。',
  'over.prejitNaBloom': 'Bloom へ',
  'over.selhalo': '認証に失敗しました',
  'over.zpetNaPrihlaseni': 'ログインに戻る',
  'oauth.ucetNenalezen': 'アカウントが見つかりません',
  'oauth.neexistujeGoogle': 'この Google アカウントに対応する Bloom のアカウントがありません。先に登録してください。',
  'oauth.neexistujeFacebook': 'この Facebook アカウントに対応する Bloom のアカウントがありません。先に登録してください。',
  'oauth.registrovatGoogle': 'Google で登録',
  'oauth.registrovatFacebook': 'Facebook で登録',
  'oauth.prihlasujiGoogle': 'Google でログイン中…',
  'oauth.prihlasujiFacebook': 'Facebook でログイン中…',
  'oauth.facebookSelhalo': 'Facebook でのログインに失敗しました',

  // ── drobnosti ─────────────────────────────────────────────────────────────
  'obecne.nacitam': '読み込み中…',
  'obecne.nezadano': '— 未記入 —',
  'obecne.neplatnaHodnota': 'その値は正しくありません。',
  'obecne.strankovani': 'ページ送り',
  'navrh.doplnteNazev': '名称を書いてください。',
  'navrh.vyberteZemi': '国を選んでください。',
  'navrh.doplnte': (p) => `記入してください：${p.co}。`,
  'kat.overenoZaznam': 'この情報が実際と合っていることを確認済み',
  'kat.prihlaskyDo': (p) => `応募は ${p.datum} まで`,

  'up.odznakAdmin': '管理者',

  'profil.zalozkaProfil': 'プロフィール',
  'profil.zalozkaGalerie': 'ギャラリー',
  'pf.lokalita': '場所',

  'cesta.legendaBarev': '色の説明',

  'hled.pocetVysledku': (p) => `（${p.pocet} 件）`,

  // ── avataři ───────────────────────────────────────────────────────────────
  'avatar.fem-pink': '長い金髪',
  'avatar.fem-lavender': '紫の髪',
  'avatar.fem-peach': '前髪ありのボブ',
  'avatar.fem-dark': '長い黒髪',
  'avatar.fem-straight': '赤い髪',
  'avatar.fem-ponytail': 'ポニーテール',
  'avatar.masc-blue': '短い金髪',
  'avatar.masc-teal': 'くしゃっとした髪',
  'avatar.masc-gray': '白髪まじり',
  'avatar.masc-short': '刈り上げ',
  'avatar.nb-mint': 'ミント色の髪',
  'avatar.nb-lilac': '高めのおだんご',
  'avatar.nb-curly': '短い巻き毛',
  'avatar.nb-sage': '肩までの髪',
  'avatar.nb-mohawk': 'モヒカン',
  'avatar.nb-undercut': 'アンダーカット',
  'avatar.nb-shaved': '坊主',
  'avatar.nb-glasses': 'めがね',
  'avatar.animal-cat': 'ねこ',
  'avatar.animal-fox': 'きつね',
  'avatar.animal-rabbit': 'うさぎ',
  'avatar.sym-flower': '花',
  'avatar.sym-butterfly': 'ちょう',
  'avatar.sym-star': '星',
  'avatar.custom': '自分の写真をアップロード',

  // ── odhlášení po nečinnosti ───────────────────────────────────────────────
  'odhl.necinnost': 'しばらく操作がなかったので、ログアウトしました。',
  'odhl.necinnostPopis': '誰もいないとき、Bloom はログインしたままにしません。',
  'odhl.zaChvili': 'まもなくログアウトします',
  'odhl.zaChviliPopis': '画面かキーボードに触れれば、ログインしたままです。',

  'reg.avatarSymboly': 'シンボル',

  'avatar.fem-bun': 'おだんご',
  'avatar.masc-navy': '豊かなあごひげ',
  'avatar.masc-brown': '横分け',
  'avatar.masc-goatee': 'やぎひげ',
  'avatar.nb-freckles': 'そばかす',
  'avatar.animal-panda': 'パンダ',
  'avatar.animal-owl': 'ふくろう',
  'avatar.sym-rainbow': '虹',
  'avatar.sym-heart': 'ハート',
  'avatar.sym-lotus': 'はす（Bloom）',

  'reg.potvrditHeslo': 'パスワードの確認',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vytvorit': '作成',
  'obecne.sdilet': '共有',
  'obecne.opravneni': 'アクセス許可',
  'obecne.pristupGalerie': '写真をアップロードするには、写真へのアクセス許可が必要です。',
  'obecne.vsechnyRegiony': 'すべての地域',
  'obecne.cesko': 'チェコ',
  'obecne.odbornici': '専門家',
  'obecne.zadnaZprava': 'メッセージはありません',
  'ucet.vyplnteEmailHeslo': 'メールアドレスとパスワードを入力してください',
  'ucet.spatneUdaje': 'メールアドレスまたはパスワードが違います',
  'ucet.googleSelhalo': 'Google でのログインに失敗しました',
  'ucet.skrytHeslo': 'パスワードを隠す',
  'ucet.emailOveren': 'メールアドレスを確認しました。',
  'ucet.emailPriklad': 'you@email.com',
  'ucet.overeniSelhalo': '認証に失敗しました。',
  'ucet.overeniSelhaloZnovu': '認証に失敗しました。もう一度お試しください。',
  'ucet.komunitniHesloPovinne': 'コミュニティパスワードは必須です',
  'ucet.zadejteKomunitniHeslo': 'コミュニティパスワードを入力…',
  'ucet.komunitniHesloPopis': 'Bloom はプライベートな場所です。パスワードはコミュニティの誰かから教えてもらえます。',
  'ucet.prezdivkaMin3': '表示名は3文字以上にしてください',
  'ucet.vyplntePrezdivku': '表示名を入力してください',
  'ucet.vasePrezdivka': 'あなたの表示名',
  'ucet.profilNeulozen': 'プロフィールを保存できませんでした',
  'ucet.anoZrusitProfil': 'はい、プロフィールを削除します',
  'heslo.min8': 'パスワードは8文字以上にしてください',
  'heslo.maleP': 'パスワードには小文字を含めてください',
  'heslo.velkeP': 'パスワードには大文字を含めてください',
  'heslo.cislo': 'パスワードには数字を含めてください',
  'heslo.specialni': 'パスワードには記号を含めてください',
  'heslo.specialniPriklad': 'パスワードには記号を含めてください（!@#$%）',
  'heslo.napoveda': '8文字以上・大文字・数字・記号を含む',
  'profil.oSobe': '自己紹介を少し…',
  'profil.zajmenaOna': '彼女',
  'profil.zajmenaJine': 'その他',
  'profil.doplnujiciText': '補足（任意）…',
  'profil.prikladOboru': '例：形成外科、家族法…',
  'komunita.soukromiNadpis': 'プライバシーを守ります',
  'komunita.soukromiText': 'Bloom で共有されたことは Bloom の中にとどまります。',
  'komunita.podporaText': 'Bloom は支え合う場所です。',
  'komunita.neniObchod': 'Bloom は売買の場ではありません。',
  'komunita.zadneObtezovani': 'いかなる嫌がらせも Bloom では許されません。',
  'komunita.oslovovani': 'だれもが使っている名前と代名詞で呼びます。',
  'komunita.jakakolivEtapa': 'あなたが旅のどこにいても。',
  'prav.kategZdravi': '健康',
  'prav.kategPravni': '法律',
  'prav.kategSocialni': '社会',
  'ot.chybaOdpoved': '回答を送信できませんでした。',
  'ot.chybaOtazka': '質問を投稿できませんでした。',
  'zk.napisteKomentar': 'コメントを書く…',
  'zpr.chybaHlasova': '音声メッセージを送信できませんでした。サーバー：',
  'zpr.chybaObrazek': '画像を送信できませんでした。サーバー：',
  'pod.nabizim': '提供します',
  'pod.coHledate': '何をお探しですか？（例：マッサージ、写真…）',
  'pod.coNabizite': '何を提供できますか？（例：料理、ヘアスタイル…）',
  'pod.lokalitaVolitelna': '場所（任意）',
  'pod.podrobnejsiPopis': '詳しい説明 *',
  'pod.vyplnteHledate': '何をお探しか書いてください。',
  'pod.vyplnteNabizite': '何を提供できるか書いてください。',
  'pod.vyplntePopis': '説明を入力してください。',
  'pod.zadnePrispevky': 'まだ投稿がありません。提供またはリクエストを作成してみましょう。',
  'svet.vybratZemi': '国を選ぶ',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ot.pridat': '質問する',
  'ot.nadpis': '質問と回答',
  'zk.pridat': 'ストーリーを追加',
  'zk.novy': '新しいストーリー',
  'zk.smazat': 'ストーリーを削除',
  'zk.zadne': 'まだストーリーがありません。最初の一人になってみませんか。',
  'akt.zadne': 'まだお知らせはありません。',
  'nav.clanky': '記事',
  'ucet.emailOdeslan': 'メールを送信しました',
  'ucet.komunitniHeslo': 'コミュニティパスワード',
  'ucet.nemateUcet': 'アカウントをお持ちでないですか？登録する',
  'ucet.muzetePrihlasit': 'これでログインできます。',
  'ucet.zapomenutePopis': 'メールアドレスを入力すると、パスワード再設定のリンクをお送りします。',
  'profil.oMneVolitelne': '自己紹介（任意）',
  'profil.prezdivka': '表示名',
  'profil.telefonVolitelne': '電話番号（任意）',
  'cesta.poznamkaVolitelna': '個人メモ（任意）',
  'okoli.vyberteLokalitu': '上で場所を選んでください',
  'hled.nadpis': '検索',
  'hled.popis': 'アプリ全体を検索 — 人、記事、ストーリー、レビュー…',
  'hled.min2': '検索するには2文字以上入力してください',
  'pod.vsechnySluzby': 'すべてのサービス',
  'domu.clenoveKomunity': 'コミュニティのメンバー',
  'zpr.zadneKonverzaceHledat': 'まだ会話がありません。上から相手を探してみてください。',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'reg.zajmenaOn': '彼',
  'reg.zajmenaOni': 'その人',
  'reg.zajmenaOno': 'それ',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.smazatFotku': '写真を削除',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.nastavteHeslo': 'ギャラリーのパスワードを設定',
  'reg.min3znaky': '3文字以上',
  'reg.zopakujteHeslo': 'パスワードを再入力',
  'hled.vBloom': 'Bloom 内を検索…',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'profil.upravitProfil': 'プロフィールを編集',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'obecne.vybratRegion': '地域を選ぶ',
  'obecne.region': '地域',
  'gal.heslemChranena': 'パスワード保護',
  'gal.hesloGalerie': 'ギャラリーのパスワード',
  'reset.nastavitHeslo': 'パスワードを設定',
  'reset.hesloObnoveno': 'パスワードを再設定しました。',
  'profil.nenalezen': 'プロフィールが見つかりません',
  'obecne.nebo': 'または',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'auth.dvfNapoveda': '認証アプリを開き、Bloom に表示された6桁を入力してください。代わりにバックアップコードを使うこともできます。',
  'auth.sifrovaniNapoveda': 'ウェブでメッセージの暗号化を有効にしている場合、アプリではまだそのアカウントにログインできません。ブラウザで bloomapp.cz をご利用ください。',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'ucet.zobrazitHeslo': 'パスワードを表示',

  // --- Mobilní aplikace: obrazovky prevzaté z puvodni verze ---
  'gal.opravduSmazat': 'この写真を削除しますか？',
  'dvf.zadejteKod': 'アプリに表示されたコードを入力',
  'sif.odemknoutAplikaci': 'アプリのロックを解除',
  'profil.odeslatZnovu': '再送信',
};

export default ja;
